// =============================================
// src/pages/PrivateListings/components/FiltersBar.jsx
// =============================================
import React, { useState, useEffect } from "react";
import { Select, Button } from "antd";

const { Option } = Select;


const FiltersBar = ({ makes = [], values, onChange, onApply, onReset, loading }) => {
  const { make } = values;
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Mobile View Component
  const MobileView = () => (
    <div style={{
      background: 'rgba(255, 255, 255, 0.05)',
      borderRadius: 12,
      padding: 20,
      marginBottom: 20,
      border: '1px solid rgba(255, 255, 255, 0.1)',
    }}>
      {/* Vehicle Make Section */}
      <div style={{ marginBottom: 16 }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 12,
        }}>
          <div style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }}>
            Vehicle Make
          </div>
          <div style={{ color: '#ffffff', fontSize: 14 }}>
            {make || 'All Makes'}
          </div>
        </div>
        
        <Select
          value={make}
          onChange={(v) => onChange({ ...values, make: v })}
          placeholder="All Makes"
          allowClear
          style={{
            width: "100%",
            background: 'rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: 6,
            color: '#ffffff',
          }}
          dropdownStyle={{
            background: '#1a1f3a',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: 6,
            marginTop: 4,
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          }}
        >
          {makes.map((m) => (
            <Option key={m} value={m} style={{ color: "#ffffff" }}>
              {m}
            </Option>
          ))}
        </Select>
      </div>

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: 12 }}>
        <Button
          onClick={onApply}
          style={{
            flex: 1,
            height: 48,
            borderRadius: 12,
            fontSize: 16,
            fontWeight: 700,
            border: "none",
            background: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 50%, #ec4899 100%)",
            color: "#ffffff",
            boxShadow: "0 4px 12px rgba(59, 130, 246, 0.4), 0 2px 8px rgba(139, 92, 246, 0.3), 0 1px 4px rgba(236, 72, 153, 0.2)",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 6px 16px rgba(59, 130, 246, 0.5), 0 4px 12px rgba(139, 92, 246, 0.4), 0 2px 8px rgba(236, 72, 153, 0.3)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.4), 0 2px 8px rgba(139, 92, 246, 0.3), 0 1px 4px rgba(236, 72, 153, 0.2)";
          }}
        >
          Apply Filters
        </Button>
        <Button
          onClick={onReset}
          style={{
            flex: 1,
            height: 48,
            borderRadius: 12,
            fontSize: 16,
            fontWeight: 700,
            background: "rgba(255, 255, 255, 0.08)",
            color: "#a0aec0",
            border: "1px solid rgba(255, 255, 255, 0.15)",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(255, 255, 255, 0.12)";
            e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.25)";
            e.currentTarget.style.color = "#ffffff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "rgba(255, 255, 255, 0.08)";
            e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.15)";
            e.currentTarget.style.color = "#a0aec0";
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  );

  // Desktop View Component
  const DesktopView = () => (
    <div style={{ display: "flex", gap: 12, alignItems: "center", margin: "16px 0 20px", flexWrap: "wrap" }}>
      <Select
        value={make}
        onChange={(v) => onChange({ ...values, make: v })}
        placeholder="Filter by Make"
        allowClear
        style={{ width: 180 }}
      >
        {makes.map((m) => (
          <Option key={m} value={m}>
            {m}
          </Option>
        ))}
      </Select>

      <Button type="primary" onClick={onApply}>
        Apply Filters
      </Button>
      <Button onClick={onReset}>
        Reset
      </Button>
    </div>
  );

  return isMobile ? <MobileView /> : <DesktopView />;
};


export default FiltersBar;